<template>
  <div>
    <h1>{{ $t('terms.canceled.title') }}</h1>
    <p>{{ $t('terms.canceled.p') }}</p>
    <Input input-type="textarea" :value="feedback" :on-change="v => (feedback = v)" />
    <Button :text="$t('terms.canceled.button')" class-name="send-feedback" />
  </div>
</template>

<script>
import { Button, Input } from '@bookis/web-components'

export default {
  name: 'RegistrationCancelled',
  components: {
    Button,
    Input
  },
  props: {
    sendFeedback: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      feedback: ''
    }
  }
}
</script>

<style lang="scss" scoped>
textarea {
  width: 100%;
  height: 111px;
}
.button {
  width: 100%;
  display: block;
  margin: 30px auto 0;
}
</style>
